import React from 'react';

/**
 * A convenient wrapper for accessing individual query parameters via the
 * URLSearchParams interface.
 */
export const useSearchParams = (search: string) => {
	return React.useMemo(() => new URLSearchParams(search), [search]);
};
